<template>
  <scoped>
    <img
      v-if="source"
      :src="source"
      :alt="title"
    >
    <img
      v-else
      :src="require('@/images/computerinfor_icon.png')"
      :alt="title"
    >
  </scoped>
</template>

<script setup lang="ts">
  import {onBeforeMount, ref} from "vue"
  import {File as FileClient} from "@/endpoints/rutsolve/rest/file"

  const props = defineProps({
    data: {
      default: null,
      required: false,
      type: String
    },
    extension: {
      default: null,
      required: false,
      type: String
    },
    title: {
      default: null,
      required: true,
      type: String
    },
    url: {
      default: null,
      required: false,
      type: String
    }
  })

  const source = ref<string>(null)

  onBeforeMount(() => {
    read()
  })

  async function read() {
    if (props.url) {
      source.value = await FileClient.read(props.url)
    } else {
      source.value = `data:image/${props.extension};base64,${props.data}`
    }
  }
</script>
